import { useSearchParams } from "@remix-run/react";

import { useUserDetails } from "~/hooks/queries/use-user-details";
import { useSession } from "~/hooks/use-session";

// AIDEV-NOTE: EVO-936 - Use showPartImages from userRelationships which properly computes
// the combined value (requires BOTH practitioner AND client to enable part images).
// Previously this incorrectly checked effectiveSettings.generatePartImages (practitioner only)
// and !!partImagePreferences (checks style prefs exist, not enablement).
export function useCanDisplayPartImages(sessionId: string) {
    const { sessionToken, parts } = useSession(sessionId);
    const { data: userRelationships } = useUserDetails();
    const isPublicSession = !!sessionToken;
    const partsHaveImages = parts.present.some((part) => part.part_image);

    // if it's a public session and the parts have images, enable.
    const isPublicSessionWithImages = isPublicSession && partsHaveImages;

    // Use server-computed showPartImages which requires BOTH:
    // 1. Practitioner has enabled generatePartImages for this client
    // 2. Client has enabled generatePartImages in their selfClientSettings
    const practitionerEnabled =
        userRelationships?.practitionerEnabledPartImages ?? false;
    const clientEnabled = userRelationships?.selfEnabledPartImages ?? false;
    const showPartImages = userRelationships?.showPartImages ?? false;

    return {
        canDisplay: isPublicSessionWithImages || showPartImages,
        practitionerEnabled,
        clientEnabled,
        isPublicSession,
    };
}
